import { generateIconNMRFile } from 'screening';
export function updateIconNMR(form) {
    const { experiments, iconNMROptions } = form;
    const { user, name, title, holder, solvent, deleteExistingHolder, autoSubmit, defaultParameters, } = iconNMROptions;
    let { firstExperimentNumber = 10 } = iconNMROptions;
    const data = {
        user,
        name,
        title,
        holder,
        experiments: [],
    };
    for (const experiment of experiments) {
        const parameters = [];
        for (const key in experiment.parameters) {
            parameters.push({ label: key, value: experiment.parameters[key] });
        }
        for (const key in defaultParameters) {
            parameters.push({ label: key, value: defaultParameters[key] });
        }
        data.experiments.push({
            experiment: experiment.name,
            experimentNumber: firstExperimentNumber++,
            solvent,
            parameters,
        });
    }
    form.iconNMR = generateIconNMRFile([data], {
        deleteExistingHolder,
        autoSubmit,
    });
}
//# sourceMappingURL=updateIconNMR.js.map